import PageType from './pageType';
import Mywp from './mywp';

export default function pushData(event = 'page_load', data = {}, pageType = PageType) {
    data.page_type = pageType;
    data.event = event;
    data.login_status = Mywp.isLoggedIn;
    data.user_id = Mywp.userData.id;

    window.dataLayer = window.dataLayer || [];

    // only push if there are no other 'page_load' events in the dataLayer
    if (event === 'page_load' && window.dataLayer.some((d) => d.event === 'page_load')) {
        return;
    }

    window.dataLayer.push(data);
}
